import { RecipeFormActions } from "../reducers/RecipeFormReducer";

export const recipeReloadForm = (): RecipeFormActions => ({
	type: "RELOAD_FORM"
});

export const recipeReloadedForm = (): RecipeFormActions => ({
	type: "FORM_REOLADED"
});
